// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Rf43","colCheckbox":"styles_colCheckbox__1TJXV"};